import { create } from 'zustand'

const SKINS = [
  {
    id:    'slate',
    name:  'Slate',
    desc:  'Tema claro profesional — para salas con luz natural',
    preview: ['#F1F5F9', '#FFFFFF', '#2563EB', '#0F172A'],
  },
  {
    id:    'command',
    name:  'Command',
    desc:  'Sala de control corporativa — azul oscuro y naranja',
    preview: ['#070C18', '#0F1729', '#3B82F6', '#F97316'],
  },
  {
    id:    'tactical',
    name:  'Tactical',
    desc:  'Infraestructura crítica — verde militar, alto contraste',
    preview: ['#060E06', '#0B160B', '#4ADE80', '#FBBF24'],
  },
]

function applyToDOM(skinId) {
  document.documentElement.setAttribute('data-skin', skinId)
}

const stored = localStorage.getItem('retaliq_skin') || 'slate'
applyToDOM(stored)

export const useSkinStore = create((set) => ({
  skin:  stored,
  skins: SKINS,

  setSkin: (id) => {
    localStorage.setItem('retaliq_skin', id)
    applyToDOM(id)
    set({ skin: id })
  },
}))
